import Button from 'Components/Button';
import Label from 'Components/Label';
import ClientesService from 'Services/Http/Clientes.service';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setId } from '../../../../redux/slices';
import SearchBar from 'Components/SearchBar';
import Paginador from 'Components/Paginador';
import ProgressBar from 'Components/ProgressBar';
import ButtonDelete from 'Components/ButtonDelete';

const ListarClienteComponente = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [clientes, setClientes] = useState([]);
  const [showPaginador, setShowPaginador] = useState(true);
  const [loader, setLoader] = useState(false);

  const [pageActive, setPageActive] = useState(0);

  const getClientes = async (page) => {
    setLoader(true);
    try {
      setClientes([]);
      setPageActive(page);
      const response = await ClientesService.getProspectos({ page });
      createRows(response.data);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  const activeExpedient = (uuid, id) => {
    const url = '/main/expediente/' + uuid + '/prospecto';
    const dataId = [];
    dataId[uuid] = id;
    dispatch(setId(dataId));
    goTo(url);
  };

  const goTo = (url) => {
    navigate(url);
  };

  const createRows = (rows) => {
    let data = rows.map((item, index) => (
      <tr
        key={'clientes-row-' + index}
        className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {item.id}
        </td>
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {item.nombreCompleto}
        </td>
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {item.edad}
        </td>
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {item.fechaNacimiento}
        </td>
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {moment(item.created_at).format('DD/MM/YYYY')}
        </td>
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {item.creador}
        </td>
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {moment(item.fechaAsignacion).format('DD/MM/YYYY')}
        </td>
        <td className="px-6 py-4" onClick={() => activeExpedient(item.uuid, item.id)}>
          {item.asignado}
        </td>
        <td className="px-6 py-4">
          <ButtonDelete id={item.id} refresh={refresh} />
        </td>
      </tr>
    ));
    setClientes(data);
    setLoader(false);
  };
  const find = async (text) => {
    setShowPaginador(false);
    setClientes([]);
    const response = await ClientesService.getAllProspectos(text);
    createRows(response.data);
  };
  const refresh = () => {
    getClientes(pageActive);
  };
  const reload = () => {
    setShowPaginador(true);
  };
  return (
    <>
      <Label text={'Prospectos'} />
      <div className="flex flex-col grid grid-cols-1 md:grid md:grid-flow-col md:grid-cols-2 md:flex-row gap-3 my-3 justify-stretch">
        <div className="flex order-2 md:order-1">
          <SearchBar find={find} reload={reload} />
        </div>
        <div className="flex order-1 md:order-2 justify-end">
          <Button
            label={'Agregar prospecto'}
            color={'primary'}
            onClick={() => goTo('/main/prospectos/crear')}
          />
        </div>
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <thead className="text-xs text-white uppercase bg-blue-500">
            <tr>
              <th scope="col" className="px-6 py-3">
                #
              </th>
              <th scope="col" className="px-6 py-3">
                Nombre completo
              </th>
              <th scope="col" className="px-6 py-3">
                Edad
              </th>
              <th scope="col" className="px-6 py-3">
                Fecha de nacimiento
              </th>
              <th scope="col" className="px-6 py-3">
                Fecha creacion
              </th>
              <th scope="col" className="px-6 py-3">
                Creado
              </th>
              <th scope="col" className="px-6 py-3">
                Fecha asignacion
              </th>
              <th scope="col" className="px-6 py-3">
                Asignado
              </th>
              <th scope="col" className="px-6 py-3"></th>
            </tr>
          </thead>
          <tbody>{clientes}</tbody>
          <tfoot>
            <tr>
              {showPaginador ? (
                <td colSpan={8}>
                  <Paginador onChange={getClientes} />
                </td>
              ) : (
                ''
              )}
            </tr>
          </tfoot>
        </table>
        {loader ? <ProgressBar /> : ''}
      </div>
    </>
  );
};

export default ListarClienteComponente;
